import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import * as fromLocationConsumerInterest from './location-consumer-interest.reducer';
import { EffectsModule } from '@ngrx/effects';
import { LocationConsumerInterestEffects } from './location-consumer-interest.effects';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('location-consumer-interest', fromLocationConsumerInterest.reducer),
    EffectsModule.forFeature([LocationConsumerInterestEffects])
  ]
})
export class LocationConsumerInterestFeatureStateModule {}
